import React from 'react'
import { ReactComponent as Users } from '../../assets/ic_users.svg';

const UsersIcon = () => <Users />;

export default UsersIcon;
